import { ContextApi } from '~/contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'ShimmerSea - Trade, earn and boost with the first DEX on the Shimmer Network',
  description:
    'ShimmerSea will be a leading decentralized exchange (DEX) on Shimmer focused on offering a premier trading experience"',
  // image: 'https://pancakeswap.finance/images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('ShimmerSea - Trade, earn and boost with the first DEX on the Shimmer Network')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('ShimmerSea - Trade, earn and boost with the first DEX on the Shimmer Network')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('ShimmerSea - Trade, earn and boost with the first DEX on the Shimmer Network')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('ShimmerSea - Trade, earn and boost with the first DEX on the Shimmer Network')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('ShimmerSea - Trade, earn and boost with the first DEX on the Shimmer Network')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('ShimmerSea')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('ShimmerSea')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('ShimmerSea')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `${t('Leaderboard')} | ${t('ShimmerSea')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('ShimmerSea - Trade, earn and boost with the first DEX on the Shimmer Network')}`,
      }
    case '/farms/auction':
      return {
        title: `${t('Farm Auctions')} | ${t('ShimmerSea')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('ShimmerSea - Trade, earn and boost with the first DEX on the Shimmer Network')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('ShimmerSea')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('ShimmerSea')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('ShimmerSea')}`,
      }
    case '/voting':
      return {
        title: `${t('Voting')} | ${t('ShimmerSea')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('Proposals')} | ${t('ShimmerSea')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('Make a Proposal')} | ${t('ShimmerSea')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('ShimmerSea Info & Analytics')}`,
        description: 'View statistics for ShimmerSea exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('ShimmerSea Info & Analytics')}`,
        description: 'View statistics for ShimmerSea exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('ShimmerSea Info & Analytics')}`,
        description: 'View statistics for ShimmerSea exchanges.',
      }
    case '/stats':
      return {
        title: `${t('Stats')} | ${t('ShimmerSea User Statistics')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('Pancake Squad')} | ${t('ShimmerSea')}`,
      }
    default:
      return null
  }
}
